import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { MorePage } from './model';

export const MorePageView = SuperCritical(({ model: m } : { model : MorePage }) => {
    const links = [] as React.ReactElement<any>[];
    if (showBerthManagersDashboardLink(m)) links.push(<BerthManagersDashboardLink model={m} key="berth" />);
    if (showSiteAdminSettingsLink(m)) links.push(<SiteAdminSettingsLink key="site-admin" />);
    if (showPilotSettingsLink(m)) links.push(<PilotSettingsLink model={m} key="pilots" />);
    if (showVesselSearchLink(m)) links.push(<VesselSearchLink model={m} key="vessel-search" />);
    /*<ReportsLink model={m} />*//* This was also commented out in the pre-typescript page */
    return (
        <div className="more pc-page-fixedwidth">
            {/*<loadingindicator params="request: Request" />*/}
            <div className="title">More</div>
            <div className="container">
                {links.length ? links : <div>No items here</div>}
            </div>
        </div>
    );
});

let BerthManagersDashboardLink = SuperCritical(({ model: { User } } : { model : MorePage }) =>
    <div className="menu-box">
        {/* TH 11/18/2016 -- TODO: SiteAdmins who don't belong to any sched auth should get a link to the first sched auth's dashboard?? Or maybe we need links for each sched auth for which the user has permissions... */}
        {/* DC 08/07/2017 -- Just having it go to the first sched auth's would be OK, going to the *main* sched auth would be better (TBD), and individual links per sched auth (for the SA) would be overkill */}
        <a className="menu-link" href={'#!berthmgrdashboard?id=' + (User() ? User()!.OrganizationId() : 0) }>
            <div className="menu-img">
                <span className="fa fa-dashboard"></span>
            </div>
            <span className="menu-item">
                <label className="menu-title">Berth Managers Dashboard</label>
                <br />
                <span className="menu-desc">Manage reservations and services at your berths.</span>
            </span>
        </a>
    </div>
);

let SiteAdminSettingsLink = SuperCritical(() =>
    <div className="menu-box">
        <a className="menu-link" href="#!siteadminsettings">
            <div className="menu-img">
                <span className="fa fa-cogs"></span>
            </div>
            <span className="menu-item">
                <label className="menu-title">Site Admin Settings</label>
                <br />
                <span className="menu-desc">Edit port names, order, and capabilities.  Manage berths and their arrangements.</span>
            </span>
        </a>
    </div>
);

let PilotSettingsLink = SuperCritical(({ model: m } : { model : MorePage }) =>
    // TH: The multiple pilot agency problem. Our solution is that each pilot agency gets its own settings page and settings link.
    // But for now, just show the link for the 1st Pilot Agency for which the user has permissions.
    // Will need to revise if ever have installation w/ multiple Pilot Agencies.
    <div className="menu-box">
        <a className="menu-link" href={'#!pilotsettings?id=' + m.Model().Pilots()!.CanManageSettingsAgencies()[0] }>
            <div className="menu-img">
                <span className="glyphicon glyphicon-cog"></span>
            </div>
            <span className="menu-item">
                <label className="menu-title">Pilot Settings</label>
                <br />
                <span className="menu-desc">Manage Pilot lists and billing configurations.</span>
            </span>
        </a>
    </div>
);

let VesselSearchLink = SuperCritical(({ model: m } : { model : MorePage}) =>
    <div className="menu-box">
        <a className="menu-link" href="#!vesselservicelisting">
            <div className="menu-img">
                <span className="icon-ship"></span>
            </div>
            <span className="menu-item">
                <label className="menu-title">Vessels</label>
                <br />
                <span className="menu-desc">View a ship's particulars and portcalls.</span>
            </span>
        </a>
    </div>
);

let ReportsLink = SuperCritical(({ model: m } : { model : MorePage }) =>
    <div className="menu-box">
        <a className="menu-link" href="#!reports">
            <img className="menu-img" src="Images/more-reports-icon.png" />
            <span className="menu-item">
                <label className="menu-title">Reports</label>
                <br />
                <span className="menu-desc">Get information summarizing a variety of port activities.</span>
            </span>
        </a>
    </div>
);

function showBerthManagersDashboardLink(m : MorePage) {
    return m.Model().CanManageBerths();
}

function showSiteAdminSettingsLink(m : MorePage) {
    return m.Model().CanSiteAdmin();
}

function showPilotSettingsLink(m : MorePage) {
    return m.Domain.Settings() &&
        m.Domain.Settings()!.HasPilots() &&
        !!m.Model().Pilots() &&
        m.Model().Pilots()!.CanManageSettingsAgencies().length;
}

function showVesselSearchLink(m : MorePage) {
    return m.Model().CanRequestBerths();
}


// WEBPACK FOOTER //
// ./apps/portcall/morepage/view.tsx